import Vue    from "vue";
import Vuex   from "vuex";
import router from '@/router/index.js'

Vue.use(Vuex);

export default new Vuex.Store({
	/**
	*	STATE
	*
	*	Responsável por armazenar os dados globais do sistema.
	*	Estes dados podem ser acessados e alterados de qualquer
	*	view ou componente de forma independente.
	*/
	state: {
		user: {},
		config: {},
		config_view_menu: {}
	},

	/**
	*	MUTATIONS
	*	
	*	Responsável por efetuar as alterações no state.
	*	Todo tipo de alteração ao state deve ser feito apenas via mutation.
	*/
	mutations: {
		CHANGE_USER(state, payload) {
			state.user = payload;
		},

		CHANGE_CONFIG(state, payload) {
			state.config = payload;
		},

		CHANGE_CONFIG_VIEW_MENU(state, payload) {
			state.config_view_menu = payload;
		},
	},

	/**
	*	ACTION
	*	
	*	Responsável criar lógicas maiores e executar mutations.
	*	Todo tipo de alteração ao state deve ser feito apenas via mutation.
	*/
	actions: {
		login(context, payload) {
			context.commit("CHANGE_USER",   payload.user);

			localStorage.auth  = true
			localStorage.token = payload.api_key
			router.push('/App');
		},

		update_config(context, payload) {
			context.commit("CHANGE_CONFIG", payload);			
		},

		update_config_view_menu(context, payload) {
			context.commit("CHANGE_CONFIG_VIEW_MENU", payload);			
		},

		update_user(context, payload) {
			context.commit("CHANGE_USER", payload);			
		}
	}
});